<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="supplier-order-main-sidebar" position="left" lockedOpen="gt-md">
        <supplier-order-main-sidebar></supplier-order-main-sidebar>
    </fuse-sidebar>

    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <table class="table">
                        <thead>
                        <tr>
                            <th style="width: 50%;">{{'Product'|translate}}</th>
                            <th style="width: 10%;">{{'Unit'|translate}}</th>
                            <th style="width: 10%;">{{'Quantity'|translate}}</th>
                            <th style="width: 10%;">{{'Price net'|translate}}</th>
                            <th style="width: 10%;">{{'Vat rate'|translate}}</th>
                            <th style="width: 10%;">{{'Price gross'|translate}}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr formArrayName="items" *ngFor="let line of items().controls; index as i">
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="product" (selectionChange)="onProductSelect(i, $event)">
                                        <mat-option [value]="product.id" *ngFor="let product of products">
                                            {{product.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="unit">
                                        <mat-option [value]="unit.id" *ngFor="let unit of units">
                                            {{unit.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="quantity">
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline"class="pr-4">
                                    <input matInput formControlName="priceNet">
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="vatRate">
                                        <mat-option [value]="vatRate.vatValue" *ngFor="let vatRate of vatRates">
                                            {{vatRate.vatName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline" class="pr-4">
                                    <input matInput formControlName="priceGross">
                                </mat-form-field>
                            </td>
                            <td><button *ngIf="i>0" (click)="removeLine(i)" mat-raised-button color="warn">{{'Remove'|translate}}</button></td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td><button type="button" (click)="addLine()" mat-raised-button color="primary">{{'Add product'|translate}}</button></td>
                        </tr>
                        </tfoot>
                    </table>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="80">
                            <mat-label>{{'Supplier'|translate}}</mat-label>
                            <mat-select formControlName="supplier">
                                <mat-option [value]="supplier.id" *ngFor="let supplier of suppliers">
                                    {{supplier.name}}
                                </mat-option>
                            </mat-select>
                            <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                        </mat-form-field>
                        <div fxFlex="20">
                            <a mat-raised-button color="primary" (click)="addSupplier()">{{'Add supplier'|translate}}</a>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Invoice number'|translate}}</mat-label>
                            <input matInput formControlName="invoiceNumber">
                            <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>{{'Description'|translate}}</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
